import {PropsWithChildren, useCallback} from 'react';
import {useNavigate} from "react-router-dom";
import {BlankLayout} from "../BlankLayout.tsx";
import {Payment} from '../view';

const PaymentScreen = () => {
    const navigate = useNavigate();

    const Layout = useCallback(({basic, children, ...props}: PropsWithChildren<{ basic?: boolean }>) => {
        return <BlankLayout
            onBack={() => {
                navigate(-1);
            }}
            {...props}
        >
            {children}
        </BlankLayout>
    }, [])

    return <Payment
        templates={{
            layout: Layout
        }}
    />
};

export {PaymentScreen};
